export default __webpack_public_path__ + "static/narration-c7b14b0b5859174ff77cff38b89b3b76.mp3";